/**
 * Puente simple entre el botón flotante de WhatsApp (App.tsx) y la pantalla
 * de envío: guarda la captura de la pantalla anterior mientras se navega,
 * para que WhatsAppSenderPage la recoja una sola vez al montar.
 * (mismo patrón que Empacadora, ver src/utils/capturaPendiente.ts allá)
 */
let capturaPendiente: File | null = null;

export function setCapturaPendiente(file: File | null) {
  capturaPendiente = file;
}

export function tomarCapturaPendiente(): File | null {
  const f = capturaPendiente;
  capturaPendiente = null;
  return f;
}
